import { ConversationBuilderState } from "@/modules/conversation-builder";
import { Component, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { ConversationNode, ConversationNodeType, Dialog } from "../../conversation-builder.model";
import StartProperties from "../start-properties/start-properties.vue";
import DialogProperties from "../dialog-properties/dialog-properties.vue";
import PathProperties from "../path-properties/path-properties.vue";
import ExternalConversationProperties from "../extenral-conversation-properties/extenral-conversation-properties.vue";

@Component({
	components: {
		StartProperties,
		DialogProperties,
		PathProperties,
		ExternalConversationProperties
	}
})
export default class ConversationProperties extends Vue {
	public conversationNodeType = ConversationNodeType;

	public conversationStore = getModule(ConversationBuilderState);

	@Watch("conversationStore.selectedNode")
	onChange() {}

	public get selectedNode() {
		return this.conversationStore.nodes[this.conversationStore?.selectedNode!];
	}

	public get nodesLength() {
		return Object.keys(this.conversationStore.nodes).length;
	}

	public get title(): string {
		if (this.isConversation) {
			return "For Conversation";
		}
		if (this.isStart) {
			return "For Start";
		}
		if (this.isDialog) {
			return "For Dialog";
		}
		if (this.isPath) {
			return "For Path";
		}
		if (this.isExternalConversation) {
			return "External Conversation";
		}
		return this.nodesLength ? "For Conversation" : "";
	}

	public get isConversation() {
		return !this.isStart && this.selectedNode?.type === ConversationNodeType.Conversation;
	}
	public get isStart() {
		return (
			this.selectedNode?.type === ConversationNodeType.Conversation && !!(this.selectedNode.data as Dialog).isHead
		);
	}
	public get isDialog() {
		return this.selectedNode?.type === ConversationNodeType.Dialog;
	}
	public get isPath() {
		return this.selectedNode?.type === ConversationNodeType.Path;
	}
	public get isExternalConversation() {
		return this.selectedNode?.type === ConversationNodeType.ExternalConversation;
	}
}
